import React from 'react';
import { Box, Hint, Inscription, List } from '@common-fe/common-fe';

import { ServiceItem, ServiceTypeValues } from '../../../Services.types';

interface ServiceItemActionsProps {
  service: ServiceItem;
  onEdit: (service: ServiceItem) => void;
  onHide: (service: ServiceItem) => void;
  onUnhide: (service: ServiceItem) => void;
}

const DISABLED_TOOLTIP_TEXT = 'Only manually added services can be edited';

const ServiceItemActions: React.FC<ServiceItemActionsProps> = ({ service, onEdit, onHide, onUnhide }) => {
  const isManualClaim = service.serviceType === ServiceTypeValues.MANUAL_CLAIM;
  const isHidden = service.serviceType === ServiceTypeValues.HIDDEN;
  const isEditable = isManualClaim || isHidden;

  const options = (
    <List.Item.Options isDisabled={!isEditable}>
      {isManualClaim && (
        <List.Item.Options.Item
          testId={`services-list_item_${service.id}_edit-action`}
          onClick={() => onEdit(service)}
        >
          Edit
        </List.Item.Options.Item>
      )}
      {isManualClaim && (
        <List.Item.Options.Item
          testId={`services-list_item_${service.id}_hide-action`}
          onClick={() => onHide(service)}
          isDanger
        >
          Hide
        </List.Item.Options.Item>
      )}
      {isHidden && (
        <List.Item.Options.Item
          testId={`services-list_item_${service.id}_unhide-action`}
          onClick={() => onUnhide(service)}
        >
          Unhide
        </List.Item.Options.Item>
      )}
    </List.Item.Options>
  );

  if (!isEditable) {
    return (
      <Box align="end">
        <Hint hintWidth={200} hintElement={options}>
          <Box direction="row" justify="center" align="center">
            <Inscription textAlign="center" size="12px" color="textOnColor" weight={500} lineHeight="18px">
              {DISABLED_TOOLTIP_TEXT}
            </Inscription>
          </Box>
        </Hint>
      </Box>
    );
  }

  return <Box align="end">{options}</Box>;
};

export default ServiceItemActions;
